'use client';
import CircularProgress from '@mui/material/CircularProgress';
import { useState, useRef, useEffect } from 'react';

import { getCpImageList } from '@/api/couple/cpInfo';
import CpMediaListCard from '@/components/cp/cpMediaListCard/cpMediaListCard';
import { InfiniteScroll } from '@/components/infiniteScroll/infiniteScroll';
import { slickOption } from '@/components/slick/slick';
import { CpImageType, DetailInfo } from '@/types/cpType';

import CpNoData from '../../components/cpNoData/cpNoData';

import style from './imagePage.module.scss';

function ImagePage({
    userId,
    imageList,
    setImageList,
    switchDetail
}: {
    userId: string;
    imageList: CpImageType[];
    setImageList: (imageList: CpImageType[]) => void;
    switchDetail: (params: DetailInfo) => void;
}) {
    const [secondRender, setSecondRender] = useState(false);
    const [isEnd, setIsEnd] = useState(false);
    const page = useRef(1);
    const isLoading = useRef(false);

    useEffect(() => {
        setSecondRender(true);
    }, []);

    const handleloadMore = async () => {
        if (!secondRender || isLoading.current) return;

        isLoading.current = true;
        page.current += 1;
        const res = await getCpImageList({ userId, page: page.current, limit: 12 });
        if (res.status === 200 && res.data.length > 0) {
            setImageList([...imageList, ...res.data]);
        } else {
            setIsEnd(true);
        }
        slickOption?.cpInfoResetHeight();
        isLoading.current = false;
    };

    useEffect(() => {
        slickOption?.cpInfoResetHeight();
    }, [imageList]);

    const changeURL = (url: string) => {
        window.history.replaceState({}, '', url);
    };

    return (
        <>
            {imageList.length > 0 ? (
                <div className={style.imagePage}>
                    <div className={style.imageList}>
                        {imageList.map((imageData, index) => (
                            <CpMediaListCard
                                className={style.cpImage}
                                key={`${imageData.id}_${index}`}
                                mediaData={imageData}
                                onClick={() => {
                                    switchDetail({
                                        isOpen: true,
                                        userId,
                                        detailId: imageData.id,
                                        type: 'image'
                                    });
                                    changeURL(`/cp/${userId}/i/${imageData.id}`);
                                }}
                            />
                        ))}
                    </div>
                    {isEnd ? (
                        <div className={style.listEnd}>{imageList.length > 0 && '已經到底嘍…'}</div>
                    ) : (
                        <InfiniteScroll onVisible={handleloadMore}>
                            <div className={style.loadMore}>
                                <CircularProgress size={24} sx={{ color: '#e52027' }} />
                            </div>
                        </InfiniteScroll>
                    )}
                </div>
            ) : (
                <CpNoData />
            )}
        </>
    );
}

export default ImagePage;
